<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-766.25 -224)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(766.25 224)" />
			<path
				d="M20.75,2A18.75,18.75,0,1,0,39.5,20.75,18.757,18.757,0,0,0,20.75,2Zm-15,18.75a15,15,0,0,1,15-15,14.817,14.817,0,0,1,9.188,3.169L8.919,29.938A14.817,14.817,0,0,1,5.75,20.75Zm15,15a14.817,14.817,0,0,1-9.187-3.169L32.581,11.563A14.817,14.817,0,0,1,35.75,20.75,15,15,0,0,1,20.75,35.75Z"
				transform="translate(768 225.75)"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-block',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconBlock

    ```js
    <b-icon-block />
    ```
</docs>
